import { from, Observable, of } from 'rxjs';
import { concatMap, first, takeWhile, last } from 'rxjs/operators';
import { AbstractControl, AsyncValidatorFn, ValidationErrors } from '@angular/forms';

/**
 * Runs the given async validators one after another (instead of Angular's default parallel
 * execution, which merges every error object) and resolves with the FIRST error found.
 * Validators after the failing one are never executed, so only one message is shown at a time.
 */
export const sequentialAsyncValidators = (validators: AsyncValidatorFn[]): AsyncValidatorFn =>
    (control: AbstractControl): Observable<ValidationErrors | null> =>
        from(validators).pipe(
            concatMap(validator => from(validator(control) ?? of(null)).pipe(first())),
            takeWhile(errors => errors === null, true),
            last(null, null)
        );

